import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Contract } from 'src/app/models/contract.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-contract-edit',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Clientes</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-settlements [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
    
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Contratos</h2>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">

            <h5>Empresa</h5>
            <p><strong>{{contract?.profile?.name}}</strong></p>
            <p class="text-sm text-muted mb-0">RFC</p>
            <p>{{contract?.profile?.rfc}}</p>
            <p class="text-sm text-muted mb-0">Dirección</p>
            <p>{{contract?.profile?.address}}</p>


          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ContractEditComponent {
  contract: Contract | null = null;

  currentView: string = 'contracts';

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService,
    private activateRoute: ActivatedRoute,
  ) {
    this.activateRoute.params.subscribe(params => {
      this.loadContract(params['id']);
    });
   }

  loadContract(id: any) {
    console.log(id);
    this.store.getContract(id).subscribe({
      next: (response: any) => {
        console.log('response', response);
        this.contract = response;
      }, error: (error: any) => {
        this.toastr.error('Error al cargar el contrato');
      }
    });
  }

}
